import { put, select } from 'redux-saga/effects';
import { loadYammerSDKOnce } from 'utils/yammer';
import { setYammerLoadedAction } from 'common/actions/settings';
import { getShareViaYammerSelector } from 'common/selectors/settings';
import { get } from 'lodash-es';

export function* loadYammerSDKEffect() {
  try {
    const yammerFeature = yield select(getShareViaYammerSelector);
    if (get(yammerFeature, 'enabled')) {
      yield loadYammerSDKOnce();
      yield put(setYammerLoadedAction());
    }
  } catch (error) {}
}
